/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABnElEQVR4nMWVPUsDQRCGr1M7Y5mItYXYiI0IdhK425k54TKTWJzR/6AS8SeZ5G+oqGUidiqoCH5Ee2VO5fJ1l00MurCwxe777LwzO+s4/zmCIJgBkm1AqRuSJhC/6/xe1wAKZdctZUYRngLiAyB+BZKPtGlQXgxyRc9YiQNIFlBOBglDN4j4wvOCuVRx39+cBZLbJBFEXvGouJocDd+4bpBLtgXlLO2Wzk+U6ZGcroXhZA/AIB8OssGxAHxN3u++/YxNQh1LgCa+o7oM8o5NIh3rCKJ8bMWVg1IfO4C4GgNIrsYPkGZsEUlrOADfWwBaQwM8v7Cs+12/sGCQH+wBKJc2ACB+Iiot6RlvozgPKHeJe5EbbTngmh1AFPJojCxGEOL1ZIAcxQAolO0BEkFU3CDvpVgUdjw0fRzDQSStRJ8Rw+nuVlEZGwBlt6cXaYPSRvV7cT7u2+yi8nODnLbc0a2Ra/1P+orHCZes3mIE388HfjjtdmnLtUm8JlQ9z+fzE1binZaVMtoVo3eC3DAobzqjNXFVS7GnWv56fAJLG95vNS7bxAAAAABJRU5ErkJggg==)
 */
export const ClockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm1-18a1 1 0 1 0-2 0v7c0 .27.1.52.3.7l3 3a1 1 0 0 0 1.4-1.4L13 11.58V5Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
